/* tslint:disable */

declare var Object: any;
export interface ProfileFileInterface {
  "profile_id": number;
  "file_description": string;
  "file_path": string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class ProfileFile implements ProfileFileInterface {
  "profile_id": number;
  "file_description": string;
  "file_path": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: ProfileFileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProfileFile`.
   */
  public static getModelName() {
    return "ProfileFile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProfileFile for dynamic purposes.
  **/
  public static factory(data: ProfileFileInterface): ProfileFile{
    return new ProfileFile(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProfileFile',
      plural: 'ProfileFiles',
      path: 'ProfileFiles',
      idName: 'id',
      properties: {
        "profile_id": {
          name: 'profile_id',
          type: 'number'
        },
        "file_description": {
          name: 'file_description',
          type: 'string'
        },
        "file_path": {
          name: 'file_path',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
